import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import UserList from '../components/Users/UserList';
import EditUser from '../components/Users/EditUser';
import ViewUser from '../components/Users/ViewUser';

const Users = () => {
  return (
    <Routes>
      <Route path="/" element={<UserList />} />
      <Route path="/edit/:id" element={<EditUser />} />
      <Route path="/edit" element={<EditUser />} />
      <Route path="/view/:id" element={<ViewUser />} />
    </Routes>
  )
}

export default Users;